import { ArrowsIcon, NavIcons, WhatsAppIcon } from "assets/icons";
import cn from "classnames";
import { useTranslation } from "react-i18next";

import { WHATSAPP_TEMPLATE_MESSAGE_COST_FCFA } from "../../constants";
import { EMarketingChannel } from "../../marketing.types";

import styles from "./ChannelCards.module.scss";

interface ChannelCardsProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const ChannelCards = ({ value, onChange, disabled }: ChannelCardsProps) => {
  const { t } = useTranslation();

  const options = [
    {
      value: "auto",
      color: "#FB3973",
      icon: <ArrowsIcon />,
      title: t("Auto (recommended)"),
      note: t("Push if app installed, else WhatsApp")
    },
    {
      value: EMarketingChannel.Push,
      color: "#4A6CF7",
      icon: <NavIcons.NotificationIcon />,
      title: t("In-app push"),
      note: `${t("Free")} · ${t("app users")}`
    },
    {
      value: EMarketingChannel.WhatsApp,
      color: "#16C350",
      icon: <WhatsAppIcon />,
      title: "WhatsApp",
      note: `${t("Free inside the 24h window")} · ~${WHATSAPP_TEMPLATE_MESSAGE_COST_FCFA} F / ${t("template")}`
    }
  ];

  return (
    <div className={styles.cards}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          disabled={disabled}
          className={cn(styles.cards__item, {
            [styles.cards__item_active]: option.value === value
          })}
          onClick={() => onChange(option.value)}
        >
          <span className={styles.cards__title}>
            <span
              className={styles.cards__icon}
              style={{
                backgroundColor: `${option.color}14`,
                color: option.color
              }}
            >
              {option.icon}
            </span>
            {option.title}
          </span>
          <span className={styles.cards__note}>{option.note}</span>
        </button>
      ))}
    </div>
  );
};

export default ChannelCards;
